<template>
  <Layout>
    <div class="bg-grey-lighter flex justify-center items-center">
      <div class="bg-white border rounded py-8 px-8 w-full md:w-2/3 lg:w-2/3">
        <div class="flex justify-start">
          <div class="w-full">
            <h2 class="login-form-title">Registration</h2>
          </div>
        </div>
        <div class="flex flex-col mt-4">
          <pt-form-group>
            <div
              slot="form-group-label"
              class="mb-2"
            >Restaurant ID <span class="font-bold text-red">*</span></div>
            <pt-form-input
              id="username"
              v-model="restoID"
              type="text"
              placeholder="Restaurant ID..."
              class="w-full mb-4"
              @keyup.enter.native="registerUser"
            />
          </pt-form-group>

          <p class="mb-2">Address</p>
          <pt-form-input
            v-model="address"
            type="text"
            placeholder="Enter restaurant address"
            class="w-full mb-4"
            @keyup.enter.native="registerUser"
          />

          <pt-form-group>
            <div
              slot="form-group-label"
              class="mb-2"
            >Commission Rate <span class="font-bold text-red">*</span></div>
            <pt-form-input
              v-model="commissionRate"
              type="number"
              placeholder="Enter commission rate"
              class="w-full mb-4"
              @keyup.enter.native="registerUser"
            />
          </pt-form-group>
          <!-- Vat -->
          <pt-form-group
            label=""
            label-for="inputCheckbox"
            class="mb-2"
          >
            <pt-form-checkbox
              v-model="vatInclusive"
              class="mr-2"
              fill-color
            >
              Vat inclusive
            </pt-form-checkbox>
          </pt-form-group>
          <pt-form-group>
            <div
              slot="form-group-label"
              class="my-2"
            >Vat <span class="font-bold text-red">*</span></div>
            <pt-form-input
              v-model="vat"
              type="number"
              placeholder="Enter vat"
              class="w-full mb-4"
            />
          </pt-form-group>
          <!-- SD -->
          <pt-form-group
            label=""
            label-for="inputCheckbox"
            class="mb-2"
          >
            <pt-form-checkbox
              v-model="sdInclusive"
              class="mr-2"
              fill-color
            >
              SD inclusive
            </pt-form-checkbox>
          </pt-form-group>
          <pt-form-group>
            <div
              slot="form-group-label"
              class="my-2"
            >SD <span class="font-bold text-red">*</span></div>
            <pt-form-input
              v-model="sd"
              type="number"
              placeholder="Enter SD"
              class="w-full mb-4"
            />
          </pt-form-group>
          <!-- SC -->
          <pt-form-group
            label=""
            label-for="inputCheckbox"
            class="mb-2"
          >
            <pt-form-checkbox
              v-model="scInclusive"
              class="mr-2"
              fill-color
            >
              SC inclusive
            </pt-form-checkbox>
          </pt-form-group>
          <pt-form-group>
            <div
              slot="form-group-label"
              class="my-2"
            >SC <span class="font-bold text-red">*</span></div>
            <pt-form-input
              v-model="sc"
              type="number"
              placeholder="Enter SC"
              class="w-full mb-4"
            />
          </pt-form-group>
          <!-- Billing cycle -->
          <p class="mb-2">Billing Cycle <span class="font-bold text-red">*</span></p>
          <pt-select
            v-model="billingCycle"
            :options="billingCycles"
            :allow-empty="false"
            track-by="id"
            label-key="label"
            class="w-full mb-4"
          />

          <p class="mb-2">Exclusivity </p>
          <pt-select
            v-model="exclusivity"
            :options="exclusivities"
            :allow-empty="false"
            track-by="id"
            label-key="label"
            class="w-full mb-4"
          />

          <p class="mb-2">Agreement Date <span class="font-bold text-red">*</span></p>
          <pt-datepicker
            v-model="agreementDate"
            label=""
            class="w-full mb-4"
          />

          <p class="mb-2">Bill Count Date <span class="font-bold text-red">*</span></p>
          <pt-datepicker
            v-model="billCountDate"
            :disabled-dates="disabledDates"
            label=""
            class="w-full mb-4"
          />

          <p class="mb-2">Restaurant's Contact Number</p>
          <pt-form-input
            v-model="restaurantContactNo"
            type="text"
            class="w-full mb-4"
            @keyup.enter.native="registerUser"
          />

          <p class="mb-2">Owner's Contact Number</p>
          <pt-form-input
            v-model="ownerContactNo"
            type="text"
            class="w-full mb-4"
            @keyup.enter.native="registerUser"
          />

          <p class="mb-2">Owner/Restaurant Email</p>
          <pt-form-input
            v-model="restaurantEmail"
            type="text"
            class="w-full mb-4"
            @keyup.enter.native="registerUser"
          />
        </div>

        <!-- <router-link
          to="/reset-password"
          class="mb-4 no-underline text-primary font-bold hover:text-primary-dark space-letters"
        >Forgot your password?</router-link> -->
        <div class="flex lg:flex-row sm:flex-col justify-start float-right">
          <div class="">
            <pt-button
              :disabled="inProgress"
              :class="{
                'opacity-50 cursor-not-allowed': inProgress
              }"
              class="login-button"
              variant="primary"
              @action="registerUser"
            >
              {{ inProgress ? 'In progress...' : 'Register' }}
              <!-- <pt-loader
                v-show="tryingToLogIn"
                icon-class="fa-spinner" /> -->
            </pt-button>
          </div>
          <!-- <div class="flex justify-center items-center sm:mt-2 lg:mt-0 sm:w-full lg:w-2/3">
            <router-link
              class="text-grey-dark font-bold no-underline hover:text-grey-darker space-letters"
              to="/signup"
            >New partner? Sign Up</router-link>
          </div> -->
        </div>
      </div>
      <pt-modal
        ref="confirmModal"
        close-button-position-in-header="right"
        size="small"
      >
        <div slot="modal-header">Please Confirm</div>
        <div slot="modal-body">Are you sure ?</div>
        <div slot="modal-footer" class="flex justify-around items-center">
          <button class="text-red focus:outline-none px-2" @click="register">Yes</button>
          <button class="text-green focus:outline-none px-2" @click="closeModal">No</button>
        </div>
      </pt-modal>
    </div>
  </Layout>
</template>

<script>
import { PtFormGroup, PtFormInput, PtFormCheckbox } from '@pathao/ui-components/esm/FormComponents';
import { PtSelect } from '@pathao/ui-components/esm/Select';
import { PtDatepicker } from '@pathao/ui-components/esm/Datepicker';
import { PtModal } from '@pathao/ui-components/esm/Modal';
import Logo from '@components/navigation/Logo';
import { CONFIRM_RESTO } from '@src/config/apiEndpoints';
import apiRequest from '@src/utils/apiRequest';
import formatDate from '@src/utils/format-date';
// import config from '@src/config';
// import appConfig from '@src/app.config';
import Layout from '@layouts/main';

const BILLING_CYCLES = [
  {
    id: 1,
    label: '7 Days',
    value: '7',
  },
  {
    id: 2,
    label: '15 Days',
    value: '15',
  }, {
    id: 3,
    label: '30 Days',
    value: '30',
  }];

const EXCLUSIVITIES = [{
  id: 1,
  label: 'Yes',
  value: 'yes',
}, {
  id: 2,
  label: 'No',
  value: 'no',
}];

export default {
  page: {
    title: 'Registration',
    // meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Layout,
    PtFormInput,
    PtFormGroup,
    Logo,
    PtSelect,
    PtDatepicker,
    PtFormCheckbox,
    PtModal,
  },
  data() {
    return {
      restoID: '',
      inProgress: false,
      address: null,
      commissionRate: '',
      vatInclusive: false,
      vat: null,
      sdInclusive: false,
      sd: null,
      scInclusive: false,
      sc: null,
      billingCycle: null,
      billingCycles: BILLING_CYCLES,
      exclusivity: null,
      exclusivities: EXCLUSIVITIES,
      agreementDate: null,
      billCountDate: null,
      ownerContactNo: null,
      restaurantContactNo: null,
      restaurantEmail: null,
      disabledDates: {
        to: new Date(),
      },
    };
  },
  methods: {
    validateForm() {
      if (!this.restoID.trim()) {
        this.$notification.warning('Restaurant ID is required');
        return false;
      }

      if (!this.commissionRate) {
        this.$notification.warning('Commission Rate is required');
        return false;
      }

      if (!this.vat) {
        this.$notification.warning('Vat is required');
        return false;
      }
      if (!this.sd) {
        this.$notification.warning('SD is required');
        return false;
      }
      if (!this.sc) {
        this.$notification.warning('SC is required');
        return false;
      }
      if (!this.billingCycle) {
        this.$notification.warning('Billing cycle is required');
        return false;
      }

      if (!this.agreementDate) {
        this.$notification.warning('Agreement date is required');
        return false;
      }

      if (!this.billCountDate) {
        this.$notification.warning('Bill count date is required');
        return false;
      }
      return true;
    },
    registerUser() {
      const isFormValid = this.validateForm();
      if (!isFormValid) {
        return false;
      }
      this.$refs.confirmModal.showModal();
    },
    register() {
      this.closeModal();

      const ISO_DATE_FORMAT = 'YYYY-MM-DD';
      const billingCycle = this.billingCycle ? this.billingCycle.value : null;
      const exclusivity = this.exclusivity ? this.exclusivity.value : null;

      let payload = {
        url: CONFIRM_RESTO,
        method: 'POST',
        data: {
          restaurant_id: this.restoID,
          address: this.address,
          commission_rate: parseFloat(this.commissionRate).toFixed(2),
          vat: this.vat,
          var: this.vat, // FIXME: In backend
          sd: this.sd,
          sc: this.sc,
          is_vat_inclusive: this.vatInclusive,
          is_sc_inclusive: this.scInclusive,
          is_sd_inclusive: this.sdInclusive,
          billing_cycle: billingCycle,
          exclusivity: exclusivity,
          agreement_date: formatDate(this.agreementDate, ISO_DATE_FORMAT),
          bill_count_date: formatDate(this.billCountDate, ISO_DATE_FORMAT),
          owner_number: this.restaurantContactNo,
          owners_contact_number: this.ownerContactNo,
          email: this.restaurantEmail,
        },
      };
      this.inProgress = true;

      apiRequest(payload)
        .then((response) => {
          // console.log(response);
          this.inProgress = false;
          if (response.data.success) {
            this.restoID = '';
            this.address = null;
            this.commissionRate = null;
            this.vatInclusive = false;
            this.sdInclusive = false;
            this.scInclusive = false;
            this.vat = null;
            this.sd = null;
            this.sc = null;
            this.billingCycle = null;
            this.exclusivity = null;
            this.agreementDate = null;
            this.billCountDate = null;
            this.ownerContactNo = null;
            this.restaurantContactNo = null;
            this.restaurantEmail = null;

            this.$notification.success('Registration Successful!');
          } else {
            this.$notification.error(response.data.message);
          }
        }).catch((err) => {
          this.inProgress = false;
          let errorMessage = (err.response && err.response.data)
            ? err.response.data.message : 'May be something is wrong. Server is down or not responding.';
          this.$notification.error(errorMessage);
        });
    },
    closeModal() {
      this.$refs.confirmModal.closeModal();
    },
  },
};
</script>

<style>
  .login-form {
    border: 1px solid #DDDDDD;
    box-shadow: 0 2px 6px 0 rgba(0,0,0,0.24);
    border-radius: 2px;
    max-height: 400px;
    overflow-y: scroll;
  }
  .login-form-label {
    font-size: 16px;
    font-weight: 600;
    color: #545454;
    text-align: left;
    line-height: 24px;
  }
  .login-form-title {
    font-size: 24px;
    font-weight: normal;
    padding: 25px 0px;
    color: #000000;
    line-height: 32px;
  }
  .pt-input-container #username, #password {
    background: #FFFFFF;
    /*border: 0.5px solid #8E8E93;*/
    border-radius: 2px;
    line-height: 24px;
    margin-bottom: 20px;
  }
  .login-button {
    height: unset;
    padding-top: 10px;
    padding-bottom: 10px;
  }
</style>
